/**
 * Componente de acción para alternar el estado de finalización de un ticket.
 * * Renderiza un botón dinámico que cambia su apariencia, icono y texto
 * dependiendo de si el ticket está marcado como completado o no.
 * * **Estados visuales**:
 * - **Completado**: Botón estilo "outline-success" con icono de doble check.
 * - **Pendiente**: Botón estilo "primary" con icono de check circular.
 * * @component
 * @param {Object} props - Propiedades del componente.
 * @param {boolean} props.IsCompleted - Indica si el ticket se encuentra actualmente en estado completado.
 * @param {Function} props.toggleCompleted - Función callback que se ejecuta al hacer clic, encargada de revertir el estado actual.
 * * @returns {JSX.Element} Un botón interactivo con estilos condicionales de Bootstrap.
 */
const TicketChangeStatus = ({ IsCompleted, toggleCompleted }) => {
  return (
    <>
      {IsCompleted ? (
        <button
          onClick={() => toggleCompleted()}
          className="btn btn-sm btn-outline-success w-100 d-flex align-items-center justify-content-center gap-2 tcs-btn"
          title="Hacer clic para reabrir ticket"
        >
          <i className="fa-solid fa-check-double"></i>
          <span className="fw-medium">Completado</span>
        </button>
      ) : (
        <button
          onClick={() => toggleCompleted()}
          className="btn btn-sm btn-primary w-100 d-flex align-items-center justify-content-center gap-2 tcs-btn"
        >
          <i className="fa-solid fa-circle-check"></i>
          <span className="fw-medium">Marcar completado</span>
        </button>
      )}
      <style>{`
        .tcs-btn {
          height: 34px;
          border-radius: 10px;
          font-size: 0.82rem;
        }
      `}</style>
    </>
  )
}

export default TicketChangeStatus
